import { render, staticRenderFns } from "./shared_groups_empty_state.vue.js?vue&type=template&id=0f4eebbc&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./shared_groups_empty_state.vue?vue&type=template&id=0f4eebbc&vue3"
import script from "./shared_groups_empty_state.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./shared_groups_empty_state.vue?vue&type=script&lang=js&vue3"
export * from "./shared_groups_empty_state.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./shared_groups_empty_state.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports